import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa";
import apiClient from "../api/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/counterSlice";
import { Modal } from "react-bootstrap";
import { Box, TextField } from "@mui/material";
import useApi from "../hooks/useApi";
import { toast } from "react-toastify";

export const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalShow, setModalShow] = React.useState(false);
  const { userId, userName } = useSelector((state) => state.auth);
  const NAVBAR_TEXTS = [
    { page: "account", text: "Account" },
    { page: "setting", text: "Settings" },
    { page: "comping", text: "Campaign" },
    { page: "campaign", text: "Campaign" },
    { page: "Campaign", text: "Campaign" },
    { page: "schedule", text: "Schedule" },
    { page: "invoice", text: "Invoices" },
    { page: "job", text: "Jobs" },
    { page: "payment", text: "Payment" },
    { page: "request", text: "Requests" },
    { page: "vehicle", text: "Vehicles" },
  ];

  const location = useLocation();
  const textToShow = NAVBAR_TEXTS.find(
    (el) => location.pathname.search(el.page) !== -1
  )?.text;
  useEffect(() => {
    const pageTitle = location.pathname.slice(1).replace(/\//g, " ");
    document.title = `RollinAdz: ${pageTitle}` || "Default Title";
  }, [textToShow]);

  const handleLogout = async () => {
    const res = await apiClient.post("/authentication/logout/");
    if (res.ok) {
      dispatch(logout());
      navigate("/");
    }
  };

  return (
    <div className="mb-5"  style={{borderBottom:"2px solid #015a96"}}>
      <div className="site-content-header  d-flex  align-items-center justify-content-between ">
        <img
          src={require("../assets/img/rolling-ads-logo.png")}
          alt=""
          className="mw-100 rolling-ads-logo"
        />
        <Box sx={{display:{sm:"inline-block" ,xs:"none"}}}>
        <h2 className="blue-clr fs-3 fs-md-5 fs-sm-6 ">{textToShow}</h2>
          </Box> 
        <div className="right-dropdown d-flex align-items-center" style={{width:"140px"}}>
          <div className="ms-auto  d-flex align-items-center">

     
          <Link to={"/chat"} className="blue-clr fs-4 pe-4">
            <i className="bi bi-chat-left-fill" />
          </Link>
          <div className="dropdown ">
            <a
              className="dropdown-toggle blue-clr fs-4 "
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {userName}
              <FaAngleDown />
            </a>
            <div
              className=" open-dropdown text-white bg-blue dropdown-menu px-3 py-2"
              aria-labelledby="dropdownMenuLink" style={{width:"140px",cursor:"pointer"}}
            >
              <h4 className="py-1">{userName} </h4>
              <p className="pb-2 m-0 fs-5 p">User ID:{userId}</p>
              <Link style={{textDecoration:"none"}} to={"/resetpassword"}>
              
             <p className="mt-1 text-light text-nowrap" >Reset  Password</p>
              </Link>
              <span   style={{backgroundColor:"white",color:"#005E9D",display:"inline-block"}}
                onClick={() => handleLogout()}
                className="py-2  px-3 mb-1 rounded-4 "
              >
                Logout
              </span>
            </div>
          </div>
          </div>
          
        </div>
      </div>


      
      <Box className="justify-content-center" sx={{display:{sm:"none" ,xs:"flex"}}}>
        <h2 className="blue-clr fs-3 fs-md-5 fs-sm-6 ">{textToShow}</h2>
          </Box>
    </div>
  );
};





